export default __webpack_public_path__ + "locales/uk-UA/ChangePasswordDialog.json?hash=115a2deaf7e6a949ca71f3f8c3085e31";